module.exports = "<mc-loading-bar></mc-loading-bar>\n\n<mc-sidebar></mc-sidebar>\n<mc-header></mc-header>\n\n<main>\n  <perfect-scrollbar>\n    <router-outlet></router-outlet>\n  </perfect-scrollbar>\n</main>\n\n<mc-toast></mc-toast>\n<mc-lab-listener></mc-lab-listener>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 10